export default "__VITE_ASSET__BTb2OJFb__"